"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomlySelectObjectValue = exports.randomlySelectEnum = void 0;
function randomlySelectEnum(anEnum) {
    const enumValues = Object.keys(anEnum)
        .map((n) => Number.parseInt(n))
        .filter((n) => !Number.isNaN(n));
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    const randomEnumValue = enumValues[randomIndex];
    return randomEnumValue;
}
exports.randomlySelectEnum = randomlySelectEnum;
function randomlySelectObjectValue(object) {
    const keys = Object.keys(object);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    return object[randomKey];
}
exports.randomlySelectObjectValue = randomlySelectObjectValue;
//# sourceMappingURL=randomlySelect.js.map